import type { MerchantCapabilities, MerchantCapabilityKey } from '@noor/eats-api';

export type CapabilityAction = 'create' | 'import' | 'hidden';

export function capabilityAction(
  capabilities: MerchantCapabilities | undefined,
  key: MerchantCapabilityKey,
): CapabilityAction {
  const capability = capabilities?.capabilities[key];
  if (!capability) return 'hidden';
  if (capability.allowed) return 'create';
  if (key === 'product_category.create' || key === 'promotion.create') {
    return 'hidden';
  }
  return capability.reason === 'integration_managed' ? 'import' : 'hidden';
}

export function canCreate(
  capabilities: MerchantCapabilities | undefined,
  key: MerchantCapabilityKey,
): boolean {
  return capabilityAction(capabilities, key) === 'create';
}

export function canImport(
  capabilities: MerchantCapabilities | undefined,
  key: MerchantCapabilityKey,
): boolean {
  return capabilityAction(capabilities, key) === 'import';
}
